module.exports = __webpack_public_path__ + "static/53-518cfbc97f42f0517cbbdc1f467cd3e9.jpg";